import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

export const NumberFormatCustom = ({ inputRef, onChange, id, name, format, value, ...props }) => {
  return (
    <NumberFormat
      {...format}
      {...props}
      id={id}
      value={value || value === 0 ? value : ''}
      getInputRef={inputRef}
      onValueChange={(values) => {
        // react-number-format v4 keeps floatValue at full precision even when
        // decimalScale rounds the display, so a pasted value with cents (e.g.
        // 4815.86) would still reach the form. When decimalScale is 0, store the
        // rounded display value so whole-dollar-only fields can't carry cents.
        const value = format?.decimalScale === 0 && values.value !== '' ? Number(values.value) : values.floatValue;
        onChange({
          target: {
            value,
            id,
            name
          }
        });
      }}
    />
  );
};
NumberFormatCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.number,
  format: PropTypes.shape({
    thousandSeparator: PropTypes.bool,
    decimalSeparator: PropTypes.bool,
    decimalScale: PropTypes.number,
    allowNegative: PropTypes.bool,
    prefix: PropTypes.string,
    suffix: PropTypes.string,
    mask: PropTypes.string
  })
};

NumberFormatCustom.defaultProps = {
  format: {},
  value: undefined
};
